import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { forkJoin, Observable, of, Subscriber } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ModaliteReunion } from 'src/app/shared/models/modaliteReunion';
import { TypeEntretien } from 'src/app/shared/models/typeEntretien';
import { Prestation, PrestationStatut, PrestationType } from 'src/app/shared/models/prestation';
import { Tache } from 'src/app/shared/models/tache';
import { Options } from '@angular-slider/ngx-slider';
import { Router } from '@angular/router';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { BonCommandeReference } from 'src/app/shared/models/bonCommandeReference';
import { Service } from 'src/app/shared/models/service';

@Component({
	selector: 'app-activitePrestation-form',
	templateUrl: './activitePrestation-form.component.html',
	styleUrls: ['./activitePrestation-form.component.scss']
})
export class ActivitePrestationFormComponent implements OnInit {
	@Input() activitePrestation: ActivitePrestation;
	@Input() prestation: Prestation;
	@Input() isAddForm: boolean;
	@Input() isAddressSelected: { value: boolean };
	@Input() isAddressDefault: { value: boolean };
	@Input() isAddressStructureSelected: { value: boolean };
	@Input() isAddressStructureDefault: { value: boolean };
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();


	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	activitePrestations: ActivitePrestation[] = null;
	serviceCotraitant: Service;

	labelIntervenantCapitalized: string;

	listModaliteReunion: ModaliteReunion[];
	listTache: Tache[];
	listTypeEntretien: TypeEntretien[];
	listIntervenant: Employee[];
	listActivite: ActivitePrestation[];
	listRelatedReferenceBdc: BonCommandeReference[];

	isPreferencesActive = false;
	totalHeuresActivites = 0;
	heuresRestantes;
	showFieldCotraitant = false;

	//options: Options;
	isIntervenant: boolean;
	user: User;
	maxDate: Date;
	minDate: Date;

	constructor(
		private logger: LogService, 
		private facade: FacadeService, 
		private router: Router,
		private dateUtils: DateUtils) {
	}

	ngOnInit(): void {
		if (this.activitePrestation) {
			this.isIntervenant = this.facade.dataStorageService.isIntervenant();
			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);
			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			this.facade.tacheService.getAllTache().subscribe({
				next: (val) => {
					this.listTache = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.typeEntretienService.getAllTypeEntretien().subscribe({
				next: (val) => {
					this.listTypeEntretien = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.employeeService.getAllActiveEmployees().subscribe({
				next: (val) => {
					this.listIntervenant = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.modaliteReunionService.getAllModaliteReunion().subscribe({
				next: (val) => {
					this.listModaliteReunion = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			const prestationId = +this.router.url.split('/').pop();
			this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
				this.facade.serviceService.getServicesByTypeHandicap(this.prestation.service.typeHandicap?.id).subscribe({
					next: (val) => {
						this.serviceCotraitant = val.find(e => e.cotraitant);
						if(this.serviceCotraitant){
							this.showFieldCotraitant=true;
							this.checkRelatedBdcLine();
						}
					},
					error: (err) => {
						this.logger.error(err);
					}
				});
			});

			this.facade.activitePrestationService.getByPrestation(this.prestation?.id).subscribe({
				next: (val) => {
					this.listActivite = val;
					this.listActivite?.forEach((activite) => {
						this.totalHeuresActivites += activite.chargeTravail;
					})
					this.heuresRestantes = this.prestation?.duree - this.totalHeuresActivites + this.activitePrestation?.chargeTravail;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			// this.options = {
			// 	floor: 0.25,
			// 	step: 0.25,
			// 	ceil: this.prestation?.duree - this.totalHeuresActivites
			// };

			// Deep copy
			//this.listSelectedIntervenant = [...this.activitePrestation.intervenants];
			if (!this.isAddForm) {
				this.form.patchValue({
					cotraitant: this.activitePrestation ? this.activitePrestation.cotraitant : false,
					description: this.activitePrestation.description,
					intervenant: this.activitePrestation.intervenant?.id,
					tache: this.activitePrestation.tache?.id,
					chargeTravail: this.activitePrestation.chargeTravail,
					modaliteReunion: this.activitePrestation.modaliteReunion?.id,
					dateEntretien:
						this.activitePrestation.dateEntretien !== null && this.activitePrestation.dateEntretien !== ''
							? new Date(this.activitePrestation.dateEntretien)
							: null,
					dateProchainEntretien:
						this.activitePrestation.dateProchainEntretien !== null && this.activitePrestation.dateProchainEntretien !== ''
							? new Date(this.activitePrestation.dateProchainEntretien)
							: null,
					typeEntretien: this.activitePrestation.typeEntretien?.id,
				});

				this.checkRelatedBdcLine();
			} 
			console.log(this.activitePrestation);

			// if(this.isIntervenant){
			// 	this.maxDate = new Date();
			// 	var date = new Date();
			// 	if(Number(new Date().toISOString().slice(0, 2)) < 22){
			// 		this.minDate = new Date(date.getFullYear(), date.getMonth()-1, 22);
			// 	}else{
			// 		this.minDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
			// 	}
			// }

		}
	}

	// ngOnChanges(): void {
	// 	// this.mapUnavailabilities();
	// }
	checkRelatedBdcLine() {
		if (this.form.get('dateEntretien').value != null && this.form.get('chargeTravail').value != "") {
			const dateEntretien = this.form.get('dateEntretien').value;
			const chargeTravail = this.form.get('chargeTravail').value;
		
			this.form.controls['bonCommandeReference'].enable();
			this.form.controls['bonCommandeReference'].setValue(null);
			this.listRelatedReferenceBdc = [];
		
			const serviceId = this.prestation.service?.id;
			const regionId = this.prestation.beneficiaire?.region?.id;
		
			this.activitePrestation.dateEntretien = dateEntretien;
			this.activitePrestation.chargeTravail = chargeTravail;
		
			const entretienDate = new Date(this.activitePrestation.dateEntretien);
		
			this.facade.bonCommandeReferenceService.getAllBonCommandeReference().subscribe({
				next: (bonCommandeRefs) => {
				// Filtrage simple : cible, service et période de validité
				this.listRelatedReferenceBdc = bonCommandeRefs.filter(f =>
					f.cible === this.prestation.statutBeneficiaire &&
					f.services?.some(e => e.id === serviceId) &&
					f.region?.id === regionId &&
					entretienDate >= this.dateUtils.convertStringToDate(f.dateDebut) &&
					entretienDate <= this.dateUtils.convertStringToDate(f.dateFin)
				);
		
				// Si un seul résultat, sélection automatique
				if (this.listRelatedReferenceBdc.length === 1) {
					this.form.controls['bonCommandeReference'].setValue(this.listRelatedReferenceBdc[0].id);
					this.form.controls['bonCommandeReference'].disable();
				}
				}
			});
		}
	  }
	  

	submitForm() {
		if (
			this.form.valid)
		 {
			this.isValidateButtonClicked.value = true;
			this.activitePrestation.cotraitant = this.form.get('cotraitant').value;
			if(this.activitePrestation.cotraitant){
				this.activitePrestation.service = this.serviceCotraitant;
			}else{
				this.activitePrestation.service = this.prestation.service;
			}
			this.activitePrestation.oldChargeTravail = this.activitePrestation.chargeTravail;
			this.activitePrestation.tache = this.listTache.find(x => x.id == this.form.get('tache').value);
			this.activitePrestation.chargeTravail = this.form.get('chargeTravail').value;
			this.activitePrestation.modaliteReunion = this.listModaliteReunion.find(x => x.id == this.form.get('modaliteReunion').value);
			this.activitePrestation.intervenant = this.listIntervenant.find(x => x.id == this.form.get('intervenant')?.value);
			this.activitePrestation.description = this.form.get('description').value;
			this.activitePrestation.typeEntretien = this.listTypeEntretien.find(x => x.id == this.form.get('typeEntretien').value);
			this.activitePrestation.dateEntretien = this.form.get('dateEntretien').value;
			if(this.listRelatedReferenceBdc?.length > 0){
				this.activitePrestation.bonCommandeReference = this.listRelatedReferenceBdc.find(x => x.id == this.form.get('bonCommandeReference').value);
			}
			if(this.totalHeuresActivites + this.activitePrestation.chargeTravail == this.prestation.duree){
				this.prestation.statut = PrestationStatut.CLOT;
				switch(this.prestation.typePrestation) { 
					case PrestationType.QD: {
						this.facade.qualificationService.updateQualification(this.prestation).subscribe({
							next: (val) => {
								if(this.isIntervenant){
									this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
										next: (val) => {
											this.activitePrestation.intervenant = val;
											this.sendForm.emit();
										},
										error: (err) => {
											this.logger.error(err);
										}
									});
								}else{
									this.sendForm.emit();
								}
							},
							error: (err) => {
								this.logger.error(err);
							}
						})	
						break;
					}
					case PrestationType.AS: {
						this.facade.situationPrestationService.updateSituationPrestation(this.prestation).subscribe({
							next: (val) => {
								if(this.isIntervenant){
									this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
										next: (val) => {
											this.activitePrestation.intervenant = val;
											this.sendForm.emit();
										},
										error: (err) => {
											this.logger.error(err);
										}
									});
								}else{
									this.sendForm.emit();
								}
							},
							error: (err) => {
								this.logger.error(err);
							}
						})	
						break
					}
					case PrestationType.AC: {
						this.facade.capaciteService.updateCapacite(this.prestation).subscribe({
							next: (val) => {
								if(this.isIntervenant){
									this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
										next: (val) => {
											this.activitePrestation.intervenant = val;
											this.sendForm.emit();
										},
										error: (err) => {
											this.logger.error(err);
										}
									});
								}else{
									this.sendForm.emit();
								}
							},
							error: (err) => {
								this.logger.error(err);
							}
						})	
						break
					}
					case PrestationType.EAP: {
						this.facade.evaluationService.updateEvaluation(this.prestation).subscribe({
							next: (val) => {
								if(this.isIntervenant){
									this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
										next: (val) => {
											this.activitePrestation.intervenant = val;
											this.sendForm.emit();
										},
										error: (err) => {
											this.logger.error(err);
										}
									});
								}else{
									this.sendForm.emit();
								}
							},
							error: (err) => {
								this.logger.error(err);
							}
						})	
						break
					}
					case PrestationType.CAMEO: {
						this.facade.miseEnOeuvreEmploiService.updateMiseEnOeuvreEmploi(this.prestation).subscribe({
							next: (val) => {
								if(this.isIntervenant){
									this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
										next: (val) => {
											this.activitePrestation.intervenant = val;
											this.sendForm.emit();
										},
										error: (err) => {
											this.logger.error(err);
										}
									});
								}else{
									this.sendForm.emit();
								}
							},
							error: (err) => {
								this.logger.error(err);
							}
						})	
						break
					}
					case PrestationType.SP: {
						this.facade.suiviPrecoService.updateSuiviPreco(this.prestation).subscribe({
							next: (val) => {
								if(this.isIntervenant){
									this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
										next: (val) => {
											this.activitePrestation.intervenant = val;
											this.sendForm.emit();
										},
										error: (err) => {
											this.logger.error(err);
										}
									});
								}else{
									this.sendForm.emit();
								}
							},
							error: (err) => {
								this.logger.error(err);
							}
						})	
						break
					}
				}
			}else{
				if(this.isIntervenant){
					this.facade.employeeService.getEmployeeById(this.facade.dataStorageService.getUser()?.id).subscribe({
						next: (val) => {
							this.activitePrestation.intervenant = val;
							this.sendForm.emit();
						},
						error: (err) => {
							this.logger.error(err);
						}
					});
				}else{
					this.sendForm.emit();
				}
			}
		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}
	get cotraitant() {
		return this.form.get('cotraitant');
	}
	get intervenant() {
		return this.form.get('intervenant');
	}
	get tache() {
		return this.form.get('tache');
	}
	get chargeTravail() {
		return this.form.get('chargeTravail');
	}
	get modaliteReunion() {
		return this.form.get('modaliteReunion');
	}
	get description() {
		return this.form.get('description');
	}
	get typeEntretien() {
		return this.form.get('typeEntretien');
	}
	get dateEntretien() {
		return this.form.get('dateEntretien');
	}
	get dateProchainEntretien() {
		return this.form.get('dateProchainEntretien');
	}
	get bonCommandeReference() {
		return this.form.get('bonCommandeReference');
	}

	calculateVolumeHoraireRefByService(bonCommandeReference: BonCommandeReference, serviceId: number, regionId: number) : Observable<number>{

		return this.facade.activitePrestationService
    .getByServiceAndRegionAndDates(
		serviceId,
		regionId,
      	bonCommandeReference.bonCommande.dateDebut,
      	bonCommandeReference.bonCommande.dateFin
    )
    .pipe(
      map(activities => {
        const filtered = activities.filter(activity =>
          activity.bonCommandeReference?.bonCommande?.id === bonCommandeReference.bonCommande.id &&
          activity.bonCommandeReference?.cible === bonCommandeReference.cible 
		  && activity.service?.id === serviceId
        );
        return filtered.reduce((sum, a) => sum + (a.chargeTravail || 0), 0);
      })
    );
	}

	
}
